
const digest = '8fbe538189394c534e2e6907548a16b9881c748d78c2e1a6947a7873d70f5661';
const classes = {"wrapper":"_wrapper_160sd_1","boldItem":"_boldItem_160sd_20","patientButton":"_patientButton_160sd_23","assignButton":"_assignButton_160sd_27","noteButton":"_noteButton_160sd_30","numberButton":"_numberButton_160sd_33","note":"_note_160sd_30"};
const css = `._wrapper_160sd_1 {
  color: #000000;
  font-size: 12px;
  font-weight: 400;
  background-color: #ffffff;
  border: 1px solid #eaedf3;
}
._wrapper_160sd_1:nth-child(even) {
  background-color: #fbfbfd;
}
._wrapper_160sd_1 td {
  padding: 14px 8px;
}
._wrapper_160sd_1 td:first-of-type {
  padding-left: 14px;
}
._wrapper_160sd_1 td:last-of-type {
  padding-right: 14px;
}
._wrapper_160sd_1 td._boldItem_160sd_20 {
  font-weight: 600;
}
._wrapper_160sd_1 td ._patientButton_160sd_23 {
  min-width: auto;
  font-size: 12px;
}
._wrapper_160sd_1 td ._assignButton_160sd_27 {
  font-size: 12px;
}
._wrapper_160sd_1 td ._noteButton_160sd_30 {
  font-size: 12px;
}
._wrapper_160sd_1 td ._numberButton_160sd_33 {
  font-size: 12px;
}
._wrapper_160sd_1 td ._note_160sd_30 {
  font-family: Rubik, "sans-serif";
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  